import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddressService } from '../services/address.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MapComponent } from "../../../shared/components/map/map.component";
import { codigoPostalValidator } from './codigo-postal.validators';
import { LoaderService } from '../../../shared/services/loader.service';

@Component({
  selector: 'app-add-direccion',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MapComponent
],
  templateUrl: './add-direccion.component.html',
  styleUrls: ['./add-direccion.component.scss']
})
export class AddDireccionComponent implements OnInit {
  direccionForm!: FormGroup;
  buscarDireccionControl = new FormControl('');
  catalogoCiudades: any[] = []; // De primer catálogo
  catalogoMunicipios: any[] = []; // Para los municipios
  selectedCiudad: { id: string, descripcion: string } | null = null;
  public ciudadIdSeleccionada: string = '';
  public municipioIdSeleccionado: string = '';
  public ciudadDescripcionSeleccionada: string = '';
  public estadoDescripcionSeleccionado: string = '';
  selectedMunicipio: { id: string, descripcion: string } | null = null;

  
  // Variables para coordenadas
  latitud: number | null = null;
  longitud: number | null = null;
  estadoSeleccionado: any = null;
  estadoEncontradoId: string = '';
  direccionSeleccionada: string = '';
  isLoadingLocation: boolean = true;
  @Input() currentMapLocation: any = null;

  private readonly baseUrl = environment.apiBaseUrl;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private addressService: AddressService,
    private loading: LoaderService,
  ) {}

  ngOnInit() {
    this.direccionForm = this.fb.group({
      identificador: ['', Validators.required],
      calleNumero: ['', Validators.required],
      interior: [''],
      codigoPostal: ['', [Validators.required, codigoPostalValidator()]],
      colonia: ['', Validators.required],
      ciudad: ['', Validators.required],
      municipio: ['', Validators.required]
    });
    this.consultarCatalogo();
    this.initializeCurrentLocation();
  }

  // Método para consultar el catálogo de ciudades
  consultarCatalogo() {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/catalog`;
    const account = localStorage.getItem('account');

    const headers = new HttpHeaders({
      'Authorization': token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    const body = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        idCatalogo: 21,
        parametros: [
          {
            clCuenta: account
          }
        ]
      }
    };

   
    
    this.http.post(url, body, { headers }).subscribe({
      next: (response: any) => {
        this.catalogoCiudades = response.catalogo;
        localStorage.setItem('catalogoCiudades', JSON.stringify(this.catalogoCiudades));
        
        // Si hay dirección previa guardada, sincronizarla con catálogos
        const direccionPrevia = localStorage.getItem('direccionPrevia');
        if (direccionPrevia) {
          const address = JSON.parse(direccionPrevia);
          this.syncAddresSatateWithCatalogs(address);
        }
      },
      error: (error) => {
        console.error('Error al consultar catálogo de ciudades:', error);
      }
    });
  }









  // Método para consultar los municipios de una ciudad

  obtenerMunicipios(address: any) {
  // Verificar si el catálogo está cargado
  if (!this.catalogoCiudades || this.catalogoCiudades.length === 0) {
    console.warn('Catálogo no cargado para municipios. Reintentando en 1 segundo...');
    setTimeout(() => {
      this.obtenerMunicipios(address);
    }, 1000);
    return;
  }
  
  const codificadoPorpin = address?.address 
  
  let estado = '';
   if(codificadoPorpin){
    const estadoEncontrado = this.syncAddresSatateWithCatalogs(address);
    estado = estadoEncontrado?.id || this.ciudadIdSeleccionada;
  }else{
    estado = this.ciudadIdSeleccionada;
  }
  
  // Si no hay estado válido, no continuar
  if(!estado) {
    console.warn('No se pudo determinar el estado para obtener municipios');
    return;
  }
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/catalog`;

    const headers = new HttpHeaders({
      'Authorization': token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    const body = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        idCatalogo: 41,
        parametros: [
          {
            codEnt: estado
          }
        ]
      }
    };
    
    // Mostrar loader mientras se cargan los municipios (solo si no está ya visible)
    if (!this.isLoadingLocation) {
      this.loading.show();
    }
    
    this.http.post(url, body, { headers }).subscribe({
      next: (response: any) => {
        this.catalogoMunicipios = response.catalogo;
        //merge con catalogo de municipios
          const municipioEncontrado =this.syncAddresMunicipioWithCatalogs(address);
       
        localStorage.setItem('catalogoMunicipios', JSON.stringify(this.catalogoMunicipios));
        
        // Ocultar loader después de un pequeño delay para asegurar que se complete el llenado
        setTimeout(() => {
          this.loading.hide();
          this.isLoadingLocation = false; // Marcar que ya no está cargando
        }, 100);
      },
      error: (error) => {
        console.error('Error al consultar catálogo de municipios:', error);
        // Ocultar loader también en caso de error
        this.loading.hide();
        this.isLoadingLocation = false;
      }
    });

  }

  syncAddresMunicipioWithCatalogs(address: any){
    const adrressPorpin = address?.address 
    if(adrressPorpin){
    const MunicipioDeseMapa = this.normalizeEstado(address.address.borough || address.address.county || '');

    const municipioEncontrado = this.catalogoMunicipios.find((item: any) => {
    return this.normalizeEstado(item.descripcion) === MunicipioDeseMapa;});
      
    if (municipioEncontrado) {
      this.selectedMunicipio = municipioEncontrado;
      this.direccionForm.patchValue({
        municipio: municipioEncontrado.id
      });
    }
    return municipioEncontrado;
  }else{
    return null;

      }
}




  syncAddresSatateWithCatalogs(address: any){
    //console.log("Haciendo merge de estados " + JSON.stringify(address, null, 2));

    // Verificar si el catálogo está cargado
    if (!this.catalogoCiudades || this.catalogoCiudades.length === 0) {
      console.warn('Catálogo de ciudades no cargado aún. Reintentando en 1 segundo...');
      setTimeout(() => {
        this.syncAddresSatateWithCatalogs(address);
      }, 1000);
      return null;
    }

    const estadoOriginal = address.address.state || '';
    let estadoDesdeMapa = this.normalizeEstado(estadoOriginal);
    
    // Caso especial: si viene "ESTADO DE MEXICO", cambiarlo a "MEXICO"
    if (estadoDesdeMapa === 'ESTADO DE MEXICO') {
      estadoDesdeMapa = 'MEXICO';
    }
    
    console.log('Estado original:', estadoOriginal);
    console.log('Estado desde mapa normalizado:', estadoDesdeMapa);
    console.log('Estados en catálogo:', this.catalogoCiudades.map(c => this.normalizeEstado(c.descripcion)));

    // Hacer merge con catalogoCiudades (que son los estados)
        const estadoEncontrado = this.catalogoCiudades.find((item: any) => {
        const descripcionNormalizada = this.normalizeEstado(item.descripcion);
        console.log(`Comparando: "${descripcionNormalizada}" === "${estadoDesdeMapa}"`);
        return descripcionNormalizada === estadoDesdeMapa;
      });

    if (estadoEncontrado) {
      this.selectedCiudad = estadoEncontrado;
      this.ciudadIdSeleccionada = estadoEncontrado.id;
      this.ciudadDescripcionSeleccionada = estadoEncontrado.descripcion;
      this.estadoEncontradoId = estadoEncontrado.id;
      this.estadoDescripcionSeleccionado = estadoEncontrado.descripcion;

      if(this.estadoEncontradoId){
        this.direccionForm.patchValue({
          ciudad: this.ciudadIdSeleccionada
        });
      }
    } else {
      console.warn('No se encontró el estado en el catálogo:', estadoDesdeMapa);
    }
      return estadoEncontrado;
  }


  getPlaces(places: any) { // cordenadas por busquedas    
    // Limpiar coordenadas anteriores
    this.latitud = null;
    this.longitud = null;
    
    // Asignar nuevas coordenadas desde la búsqueda
    if (places && places.geometry && places.geometry.location) {
      this.latitud = places.geometry.location.lat;
      this.longitud = places.geometry.location.lng;
      //console.log('Coordenadas desde búsqueda:', { lat: this.latitud, lng: this.longitud });
    }
  }

  getReverseByCordinates(cordinates: any){

    // Limpiar coordenadas anteriores
    this.latitud = null;
    this.longitud = null;
    
    // Asignar nuevas coordenadas
    if (cordinates && cordinates.lat && cordinates.lng) {
      this.latitud = cordinates.lat;
      this.longitud = cordinates.lng;
    }
  }


  normalizeEstado(estado: string): string {
  if (!estado) return '';
  
  let normalizado = estado
    .toUpperCase()
    .normalize("NFD")                      // Quitar acentos
    .replace(/[\u0300-\u036f]/g, "")      // Quitar acentos
    .replace(/[^A-Z\s]/g, "")             // Quitar símbolos
    .replace(/\s+/g, " ")                 // Quitar espacios dobles
    .trim();
    
  // Casos especiales para México - probar múltiples variantes
  if (normalizado === 'ESTADO DE MEXICO' || normalizado === 'MEXICO') {
    // Probar ambas variantes en el catálogo
    return normalizado; // Devolver tal como está para que se pruebe primero
  }
  
  // Quitar palabras comunes después de casos especiales
  const sinPalabrasComunes = normalizado
    .replace(/\b(ESTADO\s+DE|ESTADO|DE)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();
    
  return sinPalabrasComunes;
    
  return normalizado;
  }
  
  getReverseByAdreess(address: any){

    //console.log('Datos completos del mapa:', JSON.stringify(address, null, 2));
    
    // Verificar el tipo de datos recibidos
    if (address.address_components) {
      // Datos completos de Google Maps - usar estructura de address_components
      this.processGoogleMapsData(address);
    } else if (address.isOpenStreetMap && address.address) {
      // Datos de OpenStreetMap - usar para código postal, municipio y ciudad
      this.processOpenStreetMapData(address);
    }
  }
  
  processGoogleMapsData(address: any) {
    console.log('Procesando datos de Google Maps');
    
    const components = address.address_components;
    
    // Buscar colonia/localidad en Google Maps
    let colonia = '';
    
    // Primero buscar sublocality (colonia)
    const sublocalityComponent = components.find((comp: any) => 
      comp.types.includes('sublocality') || 
      comp.types.includes('sublocality_level_1') ||
      comp.types.includes('neighborhood')
    );
    
    if (sublocalityComponent) {
      colonia = sublocalityComponent.long_name;
    } else {
      // Si no hay sublocality, usar locality (población)
      const localityComponent = components.find((comp: any) => 
        comp.types.includes('locality')
      );
      if (localityComponent) {
        colonia = localityComponent.long_name;
      }
    }
    
    if (colonia) {
      console.log('Colonia procesada de Google Maps:', colonia);
      this.direccionForm.patchValue({
        colonia: colonia
      });
    }
    
    // Buscar código postal
    const postalCodeComponent = components.find((comp: any) => 
      comp.types.includes('postal_code')
    );
    
    if (postalCodeComponent) {
      this.direccionForm.patchValue({
        codigoPostal: postalCodeComponent.long_name
      });
    }
    
    // Buscar número de calle
    const streetNumberComponent = components.find((comp: any) => 
      comp.types.includes('street_number')
    );
    
    const routeComponent = components.find((comp: any) => 
      comp.types.includes('route')
    );
    
    let calleCompleta = '';
    if (routeComponent) {
      calleCompleta = routeComponent.long_name;
      if (streetNumberComponent) {
        calleCompleta += ' ' + streetNumberComponent.long_name;
      }
    }
    
    // Siempre actualizar el campo (vacío si no hay calle válida)
    this.direccionForm.patchValue({
      calleNumero: calleCompleta
    });
    
    console.log('Calle procesada:', calleCompleta || 'Campo limpiado');
    
    // Procesar estado y municipio - solo llamar obtenerMunicipios que internamente maneja el estado
    this.obtenerMunicipios(address);
  }
  
  processOpenStreetMapData(address: any) {
    console.log('Procesando datos de OpenStreetMap para CP, municipio y ciudad');
    
    // Código Postal desde OpenStreetMap
    if(address.address && address.address.postcode){
      this.direccionForm.patchValue({
        codigoPostal: address.address.postcode
      });
      console.log('Código postal desde OSM:', address.address.postcode);
    }

    // Estado/Ciudad - sincronizar con catálogo
    if (address.address && address.address.state) {
      const estadoEncontrado = this.syncAddresSatateWithCatalogs(address);
      if (estadoEncontrado) {
        console.log('Estado encontrado desde OSM:', estadoEncontrado.descripcion);
      }
    }
    
    // Municipio - obtener catálogo y sincronizar
    this.obtenerMunicipios(address);
  }

  processOpenStreetMapDataSelective(address: any) {
    console.log('Procesando datos selectivos de OpenStreetMap (solo interior, estado y municipio)');
    
    // Interior - incluir house_number
    const interior = address.address.house_number || 
                    address.address.apartment || 
                    address.address.unit || 
                    address.address.suite ||
                    address.address.floor ||
                    address.address.level;
    
    // Siempre actualizar el campo interior (vacío si no hay valor)
    this.direccionForm.patchValue({
      interior: interior || ''
    });
    
    if(interior) {
      console.log('Interior procesado desde OpenStreetMap:', interior);
    } else {
      console.log('No hay interior en OpenStreetMap - campo limpiado');
    }

    // Estado y municipio (NO llenar colonia ni código postal para evitar sobrescribir Google)
    this.obtenerMunicipios(address);
  }



onMunicipioChange(event: any) {
  const municipioId = event.value;
  this.selectedMunicipio = this.catalogoMunicipios.find(m => m.id === municipioId) || null;

  if (this.selectedMunicipio) {
    this.direccionForm.patchValue({
      codigoMunicipio: this.selectedMunicipio.id,
      descripcionMunicipio: this.selectedMunicipio.descripcion
    });
 
  }
}


onCiudadChange(event: any) {
  const id = event.value;
  this.selectedCiudad = this.catalogoCiudades.find(c => c.id === id);
  if (this.selectedCiudad) {
    this.ciudadIdSeleccionada = this.selectedCiudad.id;
    this.ciudadDescripcionSeleccionada = this.selectedCiudad.descripcion;
    this.obtenerMunicipios(this.ciudadIdSeleccionada);
  }
}



  // Método para guardar la dirección
  guardarDireccion() {
    if (this.direccionForm.invalid) {
      this.snackBar.open('Por favor completa correctamente todos los campos obligatorios.', 'Cerrar', {
        duration: 3500,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return;
    }

    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/address/${cognitoId}/registred`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });

    const formValue = this.direccionForm.value;
    let codestate = '';
    if(this.estadoEncontradoId!=null){
      codestate=this.estadoEncontradoId;
    }else{
      codestate= this.ciudadIdSeleccionada;
    }

    const body = {
      identifier: {
        tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
        app: "PortalAsistencia"
      },
      petition: {
        streetNumber: formValue.calleNumero,
        interiorDepartment: formValue.interior,
        colony: formValue.colonia,
        cp: formValue.codigoPostal,
        identifier: formValue.identificador,
        lat: this.latitud ?? null,    
        lng: this.longitud ?? null,   
        codestate: codestate, // "AS", "GR"...
        descriptionEnt: this.ciudadDescripcionSeleccionada, // "AGUASCALIENTES", etc.
        codemun:  this.selectedMunicipio?.id,   //  "00001"
        desscriptionMun: this.selectedMunicipio?.descripcion, //  "AGUASCALIENTES"
      } 
    };



    this.http.post(url, body, { headers }).subscribe({
      next: (response: any) => {

        this.snackBar.open('Dirección creada correctamente.', 'Cerrar', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        const profileDataStr = localStorage.getItem('profileData');
        if (profileDataStr) {
          const profileData = JSON.parse(profileDataStr);
          if (!profileData.address) {
            profileData.address = [];
          }

          const nuevaDireccion = response.address;
          if (nuevaDireccion) {
            profileData.address.push(nuevaDireccion);
          } else {
            console.warn('La respuesta no contiene el objeto "address"');
          }

          localStorage.setItem('profileData', JSON.stringify(profileData));
        }

      this.addressService.emitirActualizacion();
      
      // Verificar si hay URL de retorno
      const returnUrl = this.route.snapshot.queryParams['returnUrl'];
      if (returnUrl) {
        sessionStorage.setItem('addressAdded', 'true');
        this.router.navigateByUrl(returnUrl);
      } else {
        this.router.navigate(['/profile-direcciones']);
      }
    },
    error: (err) => {
      this.snackBar.open('Error al guardar la dirección', 'Cerrar', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      console.error('Error al guardar dirección:', err);
    }
  });
}

  soloNumeros(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }


  soloLetras(event: KeyboardEvent): void {
    const char = event.key;
    const regex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]$/;
    if (!regex.test(char)) {
      event.preventDefault();
    }
  }

    // Método para inicializar la ubicación actual
    initializeCurrentLocation() {
      this.isLoadingLocation = true;
      setTimeout(() => this.loading.show(), 0);
      
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.latitud = position.coords.latitude;
          this.longitud = position.coords.longitude;
          this.direccionSeleccionada = 'Obteniendo dirección...';
          // Obtener dirección real usando geocodificación inversa
          this.getAddressFromCoordinates(this.latitud, this.longitud);
        }, (error) => {
          console.log('Error obteniendo geolocalización:', error);
          // Ubicación por defecto (Bogotá)
          this.latitud = 4.617785683979158;
          this.longitud = -74.12210083036636;
          this.direccionSeleccionada = 'Ubicación por defecto';
          this.isLoadingLocation = false;
          this.loading.hide();
          this.getAddressFromCoordinates(this.latitud, this.longitud);
        });
      } else {
        // Ubicación por defecto si no hay geolocalización
        this.latitud = 4.617785683979158;
        this.longitud = -74.12210083036636;
        this.direccionSeleccionada = 'Ubicación por defecto';
        this.isLoadingLocation = false;
        this.loading.hide();
        this.getAddressFromCoordinates(this.latitud, this.longitud);
      }
    }

      // Método para obtener las coordenadas actuales
    getCurrentLocation() {
      return {
        lat: this.latitud,
        lng: this.longitud,
        address: this.direccionSeleccionada
      };
    }

    // Método para obtener la ubicación actual del mapa como dirección
    getCurrentMapLocation() {
      if (this.latitud && this.longitud) {
        return {
          lat: this.latitud,
          lng: this.longitud,
          colony: 'Ubicación actual',
          streetNumber: '',
          identifier: this.direccionSeleccionada || 'Ubicación seleccionada en el mapa',
          city: '',
          isCurrentLocation: true
        };
      }
      return null;
    }

  // Método para obtener código postal más preciso usando Google Maps Geocoding
  getPrecisePostalCode(lat: number, lng: number, fallbackCP: string, coloniaActual: string) {
    console.log(`CP ya obtenido de Google Maps: ${fallbackCP}`);
    
    // No hacer llamada adicional a Google, usar el CP que ya tenemos
    this.getColoniaByCodigoPostal(fallbackCP, coloniaActual);
  }


  // Método para mostrar mensaje informativo al usuario
  showLocationInfoMessage() {
    this.snackBar.open('Los datos se llenaron automáticamente. Verifica que sean correctos, especialmente el código postal y la colonia.', 'Entendido', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  // Método para obtener colonia usando código postal
  getColoniaByCodigoPostal(codigoPostal: string, coloniaActual: string) {
    // API gratuita de códigos postales de México
    const cpUrl = `https://api.zippopotam.us/mx/${codigoPostal}`;
    
    fetch(cpUrl)
      .then(response => response.json())
      .then(data => {
        if (data && data.places && data.places.length > 0) {
          // Buscar una colonia/localidad diferente al municipio actual
          const lugar = data.places[0];
          const nuevaColonia = lugar['place name'];
          
          // Solo actualizar si encontramos algo más específico que el municipio
          if (nuevaColonia && nuevaColonia !== coloniaActual && 
              nuevaColonia.toLowerCase() !== lugar.state.toLowerCase()) {
            console.log('Colonia encontrada por CP:', nuevaColonia);
            this.direccionForm.patchValue({
              colonia: nuevaColonia
            });
          }
        }
      })
      .catch(error => {
        console.log('No se pudo obtener información del código postal:', error);
      });
  }

  // Método para obtener dirección desde coordenadas
  getAddressFromCoordinates(lat: number, lng: number) {
    // Primero intentar con OpenStreetMap
    const osrmUrl = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`;
    
    fetch(osrmUrl)
      .then(response => response.json())
      .then(data => {

        if (data && data.display_name) {
          this.direccionSeleccionada = data.display_name;
        } else {
          this.direccionSeleccionada = 'Mi ubicación actual';
        }

        // Ya no procesamos aquí - el MapComponent se encarga de esto
        this.isLoadingLocation = false;
        this.loading.hide();

      })
      .catch(error => {
        console.log('Error obteniendo dirección:', error);
        this.direccionSeleccionada = 'Mi ubicación actual';
        this.isLoadingLocation = false;
        this.loading.hide();
      });
  }

}
